import {
  CampaignAnalyticsReport,
  ChartTypeName,
} from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { ReportSectionCard } from '@components/shared/Layout/ReportSectionCard';
import { ReportSectionCardHeaderProps } from '@components/shared/Layout/ReportSectionCardHeader';
import { Box, Typography } from '@mui/material';
import { ReactNode, ReactElement } from 'react';
import { ChartWithTakeaways } from '../ChartWithTakeaways';

type ChartCardProps = ReportSectionCardHeaderProps & {
  children: ReactElement;
  report: CampaignAnalyticsReport[ChartTypeName];
  disclaimer?: ReactNode;
};

export const ChartCard = (props: ChartCardProps) => {
  const { children, report, disclaimer, ...headerProps } = props;

  return (
    <ReportSectionCard
      title={headerProps.title}
      description={headerProps.description}
      editable={props.editable}
      includedInReport={headerProps.includedInReport}
      onChange={headerProps.onChange}
      onToggle={headerProps.onToggle}
      renderHeader={headerProps.renderHeader}
    >
      <Box>
        <ChartWithTakeaways
          takeaways={report.takeaways}
          recommendations={report.recommendations}
          editable={headerProps.editable}
          onChange={headerProps.editable ? headerProps.onChange : undefined}
        >
          {children}
        </ChartWithTakeaways>
      </Box>
      {disclaimer ? (
        <Typography mt={1} sx={{ color: '#616161', fontSize: '12px' }}>
          {disclaimer}
        </Typography>
      ) : null}
    </ReportSectionCard>
  );
};
